import type { Role } from '@/stores/session';

/** Mirrors lms LessonKind / EnrollmentStatus. */
export const LESSON_KINDS = [
  { value: 'material', label: 'Material' },
  { value: 'guide', label: 'Guide' },
  { value: 'video', label: 'Video' },
  { value: 'link', label: 'Link' },
] as const;

export type LessonKind = (typeof LESSON_KINDS)[number]['value'];

export const ENROLLMENT_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'completed', label: 'Completed' },
  { value: 'dropped', label: 'Dropped' },
] as const;

export type EnrollmentStatus = (typeof ENROLLMENT_STATUSES)[number]['value'];

export const lessonKindLabel = (s: string): string =>
  LESSON_KINDS.find((x) => x.value === s)?.label ?? s;

/** Only HR roles may manage learning content (backend IsHRorReadOnly / HR_MANAGE_ROLES). */
const LMS_MANAGE_ROLES: ReadonlySet<Role> = new Set(['super_admin', 'founder', 'hr']);

export const canManageLms = (role: Role | null): boolean =>
  role != null && LMS_MANAGE_ROLES.has(role);
